import { render, staticRenderFns } from "./BookItems.vue?vue&type=template&id=2f3f5368&scoped=true&"
import script from "./BookItems.vue?vue&type=script&lang=js&"
export * from "./BookItems.vue?vue&type=script&lang=js&"
import style0 from "./BookItems.vue?vue&type=style&index=0&id=2f3f5368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f5368",
  null
  
)

export default component.exports